import { render, staticRenderFns } from "./ClientLevelTable.vue?vue&type=template&id=72f349cc&scoped=true&"
import script from "./ClientLevelTable.vue?vue&type=script&lang=js&"
export * from "./ClientLevelTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientLevelTable.vue?vue&type=style&index=0&id=72f349cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f349cc",
  null
  
)

export default component.exports